'use client';

import { useState } from 'react';
import styles from '../../styles/FAQ.module.css';
import { FaPlus, FaMinus } from 'react-icons/fa6';

export interface ItemType {
    id: number;
    Question?: string;
    Answer?: string;
}

export default function Section({ data, index }: { data: any; index: number }) {
    const {
        // prettier-ignore
        Title = '',
        FAQItem = [],
    } = data ?? {};

    const [openId, setOpenId] = useState<number | null>(null);

    return (
        <section id={`section-${index}`} className={styles.FAQSection}>
            <section className="mx-auto max-w-[1100px]">
                <p className="font-bold text-2xl mb-4 capitalize">
                    {index}- {Title}
                </p>
                <div className="grid grid-cols-4">
                    <div className="col-span-3">
                        <div className="border rounded-md divide-y">
                            {(FAQItem ?? []).map((item: ItemType) => {
                                const q = item?.Question ?? '';
                                const a = item?.Answer ?? '';
                                const isOpen = item.id === openId;

                                return (
                                    <div key={item.id}>
                                        <button type="button" className="flex w-full items-center justify-between px-4 py-3 text-left" onClick={() => setOpenId(isOpen ? null : item.id)}>
                                            <span className="text-[#0096d4] font-medium">{q}</span>
                                            {isOpen ? <FaMinus /> : <FaPlus />}
                                        </button>
                                        {isOpen && <div className="px-4 pb-4 text-sm text-gray-700">{a}</div>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
}
